export const getHeaders = () => ({
  'Content-Type': 'application/json',
  'CF-Access-Client-Id': process.env
    .NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_ID as string,
  'CF-Access-Client-Secret': process.env
    .NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_SECRET as string,
})
